import { render, staticRenderFns } from "./BranchesDropdown.vue?vue&type=template&id=4d4f05e5&"
import script from "./BranchesDropdown.vue?vue&type=script&lang=js&"
export * from "./BranchesDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports